import {
    BOOLEAN_DEFINITION_PAYLOAD_TYPE,
    BOOLEAN_PAYLOAD_TYPE,
    LONG_TEXT_DEFINITION_PAYLOAD_TYPE,
    LONG_TEXT_PAYLOAD_TYPE,
    SELECTION_DEFINITION_PAYLOAD_TYPE,
    SELECTION_PAYLOAD_TYPE,
    SHORT_TEXT_DEFINITION_PAYLOAD_TYPE,
    SHORT_TEXT_PAYLOAD_TYPE,
    SET_SELECT_OPTION_APPEARANCE_TYPE,
    ADD_SELECT_OPTION_TYPE,
    RENAME_SELECT_OPTION_TYPE,
    REMOVE_SELECT_OPTION_TYPE,
    UPDATE_SELECTION_DEFINITION_PAYLOAD_TYPE
} from 'app/store/__generated__/types';

export const SHORT_TEXT_DEFINITION = SHORT_TEXT_DEFINITION_PAYLOAD_TYPE;
export const LONG_TEXT_DEFINITION = LONG_TEXT_DEFINITION_PAYLOAD_TYPE;
export const SINGLE_SELECT_DEFINITION = SELECTION_DEFINITION_PAYLOAD_TYPE;
export const BOOLEAN_DEFINITION = BOOLEAN_DEFINITION_PAYLOAD_TYPE;

export const SHORT_TEXT = SHORT_TEXT_PAYLOAD_TYPE;
export const LONG_TEXT = LONG_TEXT_PAYLOAD_TYPE;
export const SINGLE_SELECT = SELECTION_PAYLOAD_TYPE;

const BOOLEAN = BOOLEAN_PAYLOAD_TYPE;

export const SELECT_OPTION_APPEARANCE = SET_SELECT_OPTION_APPEARANCE_TYPE;
export const ADD_SELECT_OPTION = ADD_SELECT_OPTION_TYPE;
export const RENAME_SELECT_OPTION = RENAME_SELECT_OPTION_TYPE;
export const REMOVE_SELECT_OPTION = REMOVE_SELECT_OPTION_TYPE;
export const UPDATE_SELECTION_DEFINITION = UPDATE_SELECTION_DEFINITION_PAYLOAD_TYPE;

export const CustomPropertyDefinitionTypes = [
    SHORT_TEXT_DEFINITION,
    LONG_TEXT_DEFINITION,
    SINGLE_SELECT_DEFINITION,
    BOOLEAN_DEFINITION
];

export const CustomPropertyDefinitionToTypes = {
    [SHORT_TEXT_DEFINITION]: SHORT_TEXT,
    [LONG_TEXT_DEFINITION]: LONG_TEXT,
    [SINGLE_SELECT_DEFINITION]: SINGLE_SELECT,
    [BOOLEAN_DEFINITION]: BOOLEAN
};

export const CustomPropertyI18nKeys = {
    [SHORT_TEXT_DEFINITION]: 'ShortText',
    [LONG_TEXT_DEFINITION]: 'LongText',
    [SINGLE_SELECT_DEFINITION]: 'Selection',
    [BOOLEAN_DEFINITION]: 'Boolean'
};
export enum CustomPropertyTargets {
    COLUMN = 'COLUMN',
    SOURCE_LOCATION = 'SOURCE_LOCATION',
    DATASET = 'DATASET',
    SPACE = 'SPACE'
}
